function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { GiveawayUserTags, GiveawayType } from '@/types/client';
import UserLevelTag from '../UserLevelTag';
import { serializeProviderUserId } from '@/utils/user';
import SearchInput from '../SearchInput';
import EmptyState from '../EmptyState';
import { AutoSizer, List } from 'react-virtualized';
import { UserLevels } from '@/types/server';
import useGiveawayStore from '@/stores/GiveawayStore';
import GiveawayWinnerModal from './GiveawayWinnerModal';
import { SocketContext } from '../providers/SocketProvider';
import { LuckBasedGiveaways } from '@/utils/constants';
import { generateSecureRandomNumber } from '@/utils/random';
import { getUserLevelsFromProviderUser } from '@/utils/userlevel';
import dayjs from 'dayjs';
import GiveawayMenu from './GiveawayMenu';
import { useShallow } from 'zustand/react/shallow';
import { useDebounce } from 'use-debounce';
import styles from './GiveawayUserEntryList.module.scss';
import { Badge, Button, Checkbox, Divider, Loader, Text } from '@mantine/core';
import classNames from 'classnames';
import Icon, { IconSizes } from '../Icon';
var ROW_HEIGHT = 42;
function ProviderUserEntryListItem(_param) {
    var user = _param.user, preventPhraseSpam = _param.preventPhraseSpam, handleToggleManualRemoval = _param.handleToggleManualRemoval, props = _object_without_properties(_param, [
        "user",
        "preventPhraseSpam",
        "handleToggleManualRemoval"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        style: {
            height: ROW_HEIGHT
        },
        className: styles.entry
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(UserLevelTag, {
                userLevel: user.userType,
                showName: false,
                showIcon: true
            }),
            /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: classNames(_define_property({}, styles.entryTextDisabled, !user.eligible)),
                children: user.displayName
            }),
            user.tags.has(GiveawayUserTags.WINNER) ? /*#__PURE__*/ _jsx(Badge, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "H+vBOj",
                    defaultMessage: "Winner"
                })
            }) : null,
            preventPhraseSpam && user.tags.has(GiveawayUserTags.KEYWORD_SPAM) ? /*#__PURE__*/ _jsx(Badge, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "pI23lM",
                    defaultMessage: "Keyword Spam"
                })
            }) : null,
            user.tags.has(GiveawayUserTags.MANUAL_REMOVAL) ? /*#__PURE__*/ _jsx(Badge, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "KGzfLt",
                    defaultMessage: "Removed"
                })
            }) : null,
            user.tags.has(GiveawayUserTags.WRONG_USER_LEVEL) ? /*#__PURE__*/ _jsx(Badge, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "M44fcG",
                    defaultMessage: "Wrong User Level"
                })
            }) : null,
            user.tags.has(GiveawayUserTags.NOT_ACTIVE) ? /*#__PURE__*/ _jsx(Badge, {
                size: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "KVnNuK",
                    defaultMessage: "Not Active"
                })
            }) : null,
            handleToggleManualRemoval != null ? /*#__PURE__*/ _jsx(Checkbox, {
                color: "green",
                className: styles.checkbox,
                disabled: !user.eligible && !user.tags.has(GiveawayUserTags.MANUAL_REMOVAL),
                checked: user.eligible,
                onChange: function() {
                    return handleToggleManualRemoval();
                },
                size: "xs"
            }) : null
        ]
    }));
}
export function VirtualizedProviderUserEntryList(param) {
    var users = param.users, entries = param.entries, preventPhraseSpam = param.preventPhraseSpam, handleToggleManualRemoval = param.handleToggleManualRemoval;
    return /*#__PURE__*/ _jsx(AutoSizer, {
        children: function(param) {
            var height = param.height, width = param.width;
            return /*#__PURE__*/ _jsx(List, {
                height: height,
                width: width,
                rowCount: entries.length,
                rowHeight: ROW_HEIGHT,
                rowRenderer: function(param) {
                    var index = param.index, key = param.key, style = param.style;
                    var serializedUserId = entries[index];
                    var user = users.get(serializedUserId);
                    if (user == null) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsx(ProviderUserEntryListItem, {
                        user: user,
                        preventPhraseSpam: preventPhraseSpam,
                        handleToggleManualRemoval: function() {
                            return handleToggleManualRemoval === null || handleToggleManualRemoval === void 0 ? void 0 : handleToggleManualRemoval(serializedUserId);
                        },
                        style: style
                    }, key);
                }
            });
        }
    });
}
function ProviderUserEntriesList(param) {
    var users = param.users, entries = param.entries, canPickWinner = param.canPickWinner, preventPhraseSpam = param.preventPhraseSpam, handleResetGiveawayEntries = param.handleResetGiveawayEntries, handleToggleManualRemoval = param.handleToggleManualRemoval, updateWinner = param.updateWinner, onEditGiveaway = param.onEditGiveaway;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(''), 2), search = _React_useState[0], setSearch = _React_useState[1];
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    var hasSearch = search.length > 0;
    var filteredEntries = React.useMemo(function() {
        var normalizedQuery = debouncedSearch.toLowerCase();
        return normalizedQuery.length > 0 ? entries.filter(function(providerUserId) {
            var _user_displayName, _user_name, _user_userType;
            var user = users.get(providerUserId);
            if (user == null) {
                return false;
            }
            var _user_userType_toLowerCase_includes;
            return ((_user_displayName = user.displayName) === null || _user_displayName === void 0 ? void 0 : _user_displayName.toLowerCase().includes(normalizedQuery)) || ((_user_name = user.name) === null || _user_name === void 0 ? void 0 : _user_name.toLowerCase().includes(normalizedQuery)) || ((_user_userType_toLowerCase_includes = (_user_userType = user.userType) === null || _user_userType === void 0 ? void 0 : _user_userType.toLowerCase().includes(normalizedQuery)) !== null && _user_userType_toLowerCase_includes !== void 0 ? _user_userType_toLowerCase_includes : false);
        }) : entries;
    }, [
        debouncedSearch,
        entries,
        users
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsx(SearchInput, {
                        size: "xs",
                        placeholder: intl.formatMessage({
                            id: "GcFW3v",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search participants..."
                                }
                            ]
                        }),
                        search: search,
                        setSearch: setSearch,
                        disabled: entries.length === 0,
                        variant: "filled"
                    }),
                    /*#__PURE__*/ _jsx(GiveawayMenu, {
                        onEditGiveaway: onEditGiveaway,
                        onReset: handleResetGiveawayEntries,
                        users: users,
                        entries: entries
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            filteredEntries.length > 0 ? /*#__PURE__*/ _jsx("div", {
                className: styles.entries,
                children: /*#__PURE__*/ _jsx(VirtualizedProviderUserEntryList, {
                    users: users,
                    entries: filteredEntries,
                    handleToggleManualRemoval: handleToggleManualRemoval,
                    preventPhraseSpam: preventPhraseSpam
                })
            }) : /*#__PURE__*/ _jsx("div", {
                className: styles.emptyState,
                children: !hasSearch ? /*#__PURE__*/ _jsx(EmptyState, {
                    title: intl.formatMessage({
                        id: "jxoTMA",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Viewers Entries"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "ENJThp",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Viewers will appear here as they enter"
                            }
                        ]
                    }),
                    icon: /*#__PURE__*/ _jsx(Loader, {
                        type: "bars",
                        size: "sm"
                    })
                }) : /*#__PURE__*/ _jsx(EmptyState, {
                    title: intl.formatMessage({
                        id: "k8bltk",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "No Results"
                            }
                        ]
                    }),
                    icon: /*#__PURE__*/ _jsx(Icon, {
                        size: IconSizes.LG,
                        icon: faMagnifyingGlass
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.footer,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "xs",
                        variant: "inverse",
                        onClick: function() {
                            return updateWinner();
                        },
                        disabled: !canPickWinner,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "3CjoCg",
                            defaultMessage: "Choose a Winner"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        size: "sm",
                        className: styles.entryCount,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "uX8jTr",
                            defaultMessage: "{count, plural, one {# Entry} other {# Entries}}",
                            values: {
                                count: entries.length
                            }
                        })
                    })
                ]
            })
        ]
    });
}
export default function GiveawayEntriesList(param) {
    var channel = param.channel, onComplete = param.onComplete, onEditGiveaway = param.onEditGiveaway;
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            eligibility: state.eligibility,
            type: state.type,
            luck: state.luck,
            users: state.users,
            uniqueWinners: state.uniqueWinners,
            activityTimeout: state.activityTimeout,
            preventPhraseSpam: state.preventPhraseSpam,
            phrase: state.phrase,
            setUser: state.setUser,
            setUsers: state.setUsers
        };
    })), eligibility = _useGiveawayStore.eligibility, type = _useGiveawayStore.type, luck = _useGiveawayStore.luck, users = _useGiveawayStore.users, uniqueWinners = _useGiveawayStore.uniqueWinners, activityTimeout = _useGiveawayStore.activityTimeout, preventPhraseSpam = _useGiveawayStore.preventPhraseSpam, phrase = _useGiveawayStore.phrase, setUser = _useGiveawayStore.setUser, setUsers = _useGiveawayStore.setUsers;
    var socketClient = React.useContext(SocketContext);
    var _React_useState = _sliced_to_array(React.useState([]), 2), entries = _React_useState[0], setEntries = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), winner = _React_useState1[0], setWinner = _React_useState1[1];
    var intl = useIntl();
    var canPickWinner = React.useMemo(function() {
        if (entries.length === 0) {
            return false;
        }
        if (winner != null && entries.length === 1) {
            return false;
        }
        return entries.some(function(entry) {
            var _users_get;
            return ((_users_get = users.get(entry)) === null || _users_get === void 0 ? void 0 : _users_get.eligible) === true;
        });
    }, [
        entries,
        users,
        winner
    ]);
    var updateUserEligibility = React.useCallback(function(giveawayUser) {
        var tags = giveawayUser.tags;
        giveawayUser.eligible = !tags.has(GiveawayUserTags.WRONG_USER_LEVEL) && !tags.has(GiveawayUserTags.NOT_ACTIVE) && !tags.has(GiveawayUserTags.MANUAL_REMOVAL) && !(uniqueWinners && tags.has(GiveawayUserTags.WINNER)) && !(preventPhraseSpam && tags.has(GiveawayUserTags.KEYWORD_SPAM));
    }, [
        preventPhraseSpam,
        uniqueWinners
    ]);
    var handleUpdateUser = React.useCallback(function(giveawayUser) {
        updateUserEligibility(giveawayUser);
        return setUser(giveawayUser);
    }, [
        updateUserEligibility,
        setUser
    ]);
    var checkUserLevelEligibility = React.useCallback(function(user) {
        var userLevels = getUserLevelsFromProviderUser(user);
        var hasEligibleUserlevel = userLevels.some(function(level) {
            return eligibility.includes(level);
        });
        if (!hasEligibleUserlevel) {
            user.tags.add(GiveawayUserTags.WRONG_USER_LEVEL);
        } else {
            user.tags.delete(GiveawayUserTags.WRONG_USER_LEVEL);
        }
    }, [
        eligibility
    ]);
    var checkUserActivity = React.useCallback(function(user) {
        if (type === GiveawayType.ACTIVE_USER && dayjs().diff(dayjs(user.activeAt), 'minute') > activityTimeout) {
            user.tags.add(GiveawayUserTags.NOT_ACTIVE);
        } else {
            user.tags.delete(GiveawayUserTags.NOT_ACTIVE);
        }
    }, [
        activityTimeout,
        type
    ]);
    var handleToggleManualRemoval = React.useCallback(function(serializedUserId) {
        var user = users.get(serializedUserId);
        if (user == null) {
            return;
        }
        if (user.eligible) {
            user.tags.add(GiveawayUserTags.MANUAL_REMOVAL);
        } else {
            user.tags.delete(GiveawayUserTags.MANUAL_REMOVAL);
        }
        handleUpdateUser(user);
    }, [
        users,
        handleUpdateUser
    ]);
    var handleResetGiveawayEntries = React.useCallback(function() {
        setWinner(null);
        setEntries([]);
        setUsers(new Map());
    }, [
        setUsers
    ]);
    React.useEffect(function() {
        handleResetGiveawayEntries();
    }, [
        type,
        channel._id,
        handleResetGiveawayEntries
    ]);
    function handleSelectRandomWinner() {
        var attempt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var validEntries = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                var user = users.get(entry);
                if (user == null) {
                    continue;
                }
                checkUserLevelEligibility(user);
                checkUserActivity(user);
                handleUpdateUser(user);
                if (!user.eligible) {
                    continue;
                }
                validEntries.push(user);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (LuckBasedGiveaways.has(type) && !Object.values(luck).every(function(l) {
            return l === 1;
        })) {
            validEntries = validEntries.flatMap(function(user) {
                var _luck_user_userType;
                return Array.from({
                    length: (_luck_user_userType = luck[user.userType]) !== null && _luck_user_userType !== void 0 ? _luck_user_userType : 1
                }, function() {
                    return user;
                });
            });
        }
        var newWinner = validEntries[Math.floor(generateSecureRandomNumber() * validEntries.length)];
        if (winner != null && serializeProviderUserId(newWinner) === serializeProviderUserId(winner) && attempt < 3) {
            handleSelectRandomWinner(attempt + 1);
            return;
        }
        onComplete(newWinner);
        newWinner.tags.add(GiveawayUserTags.WINNER);
        handleUpdateUser(newWinner);
        setWinner(newWinner);
    }
    React.useEffect(function() {
        var updateActiveEntries = function updateActiveEntries() {
            setUsers(function(oldUsers) {
                var newUsers = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(oldUsers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), giveawayUserId = _step_value[0], giveawayUser = _step_value[1];
                        checkUserActivity(giveawayUser);
                        updateUserEligibility(giveawayUser);
                        newUsers.set(giveawayUserId, giveawayUser);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newUsers;
            });
        };
        if (type !== GiveawayType.ACTIVE_USER) {
            return;
        }
        var interval = setInterval(updateActiveEntries, 3 * 1000);
        updateActiveEntries();
        return function() {
            return clearInterval(interval);
        };
    }, [
        type,
        activityTimeout,
        setUsers,
        checkUserActivity,
        updateUserEligibility
    ]);
    React.useEffect(function() {
        setUsers(function(oldUsers) {
            var newUsers = new Map();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(oldUsers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _sliced_to_array(_step.value, 2), giveawayUserId = _step_value[0], giveawayUser = _step_value[1];
                    checkUserLevelEligibility(giveawayUser);
                    updateUserEligibility(giveawayUser);
                    newUsers.set(giveawayUserId, giveawayUser);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return newUsers;
        });
    }, [
        setUsers,
        checkUserLevelEligibility,
        updateUserEligibility
    ]);
    React.useEffect(function() {
        var handleChatMessage = function handleChatMessage(payload) {
            return _handleChatMessage.apply(this, arguments);
        };
        if (socketClient == null) {
            return;
        }
        function _handleChatMessage() {
            _handleChatMessage = _async_to_generator(function(payload) {
                var user, message, serializedUserId, giveawayUser, isNewEntry;
                return _ts_generator(this, function(_state) {
                    user = payload.user, message = payload.message;
                    if (user.userType === UserLevels.OWNER) {
                        return [
                            2
                        ];
                    }
                    serializedUserId = serializeProviderUserId(user);
                    giveawayUser = users.get(serializedUserId);
                    isNewEntry = giveawayUser == null;
                    if (giveawayUser == null) {
                        // If the user is not in the list, we need to check if they are eligible to join
                        if (type === GiveawayType.KEYWORD && !message.toLowerCase().includes(phrase.toLowerCase())) {
                            return [
                                2
                            ];
                        }
                        giveawayUser = _object_spread_props(_object_spread({}, user), {
                            tags: new Set(),
                            eligible: true,
                            activeAt: new Date().toISOString()
                        });
                    } else {
                        giveawayUser = _object_spread_props(_object_spread({}, giveawayUser, user), {
                            activeAt: new Date().toISOString()
                        });
                        // If the user is already in the list, we need to check if they are spamming the keyword
                        if (type === GiveawayType.KEYWORD && message.toLowerCase().includes(phrase.toLowerCase())) {
                            giveawayUser.tags.add(GiveawayUserTags.KEYWORD_SPAM);
                        }
                    }
                    checkUserLevelEligibility(giveawayUser);
                    checkUserActivity(giveawayUser);
                    handleUpdateUser(giveawayUser);
                    if (isNewEntry) {
                        setEntries(function(prev) {
                            return [
                                serializedUserId
                            ].concat(_to_consumable_array(prev));
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return _handleChatMessage.apply(this, arguments);
        }
        socketClient.on('chatMessage', handleChatMessage);
        return function() {
            socketClient.off('chatMessage', handleChatMessage);
        };
    }, [
        eligibility,
        entries,
        winner,
        socketClient,
        users,
        luck,
        type,
        phrase,
        handleUpdateUser,
        checkUserLevelEligibility,
        checkUserActivity
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ProviderUserEntriesList, {
                users: users,
                entries: entries,
                canPickWinner: canPickWinner,
                preventPhraseSpam: preventPhraseSpam,
                handleToggleManualRemoval: handleToggleManualRemoval,
                handleResetGiveawayEntries: handleResetGiveawayEntries,
                updateWinner: handleSelectRandomWinner,
                onEditGiveaway: onEditGiveaway
            }),
            /*#__PURE__*/ _jsx(GiveawayWinnerModal, {
                onClose: function() {
                    return setWinner(null);
                },
                winner: winner,
                channel: channel,
                canConfirm: canPickWinner,
                onConfirm: function() {
                    return handleSelectRandomWinner();
                },
                confirmText: intl.formatMessage({
                    id: "TsQfdy",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reroll Winner"
                        }
                    ]
                })
            })
        ]
    });
}
